import { render, staticRenderFns } from "./ChainDetail.vue?vue&type=template&id=93122c12&scoped=true"
import script from "./ChainDetail.vue?vue&type=script&lang=js"
export * from "./ChainDetail.vue?vue&type=script&lang=js"
import style0 from "./ChainDetail.vue?vue&type=style&index=0&id=93122c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93122c12",
  null
  
)

export default component.exports